import { render, staticRenderFns } from "./CovidScreeningSmsMessages.vue?vue&type=template&id=280b9658&"
import script from "./CovidScreeningSmsMessages.vue?vue&type=script&lang=js&"
export * from "./CovidScreeningSmsMessages.vue?vue&type=script&lang=js&"
import style0 from "./CovidScreeningSmsMessages.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports